import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sold-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  tabText = 'More Info';
  constructor() { }

  ngOnInit() {
  }

  toggleSideTab() {
    if (this.tabText === 'More Info') {
      this.tabText = 'Summary';
    } else {
      this.tabText = 'More Info';
    }
  }
}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/sidebar/sidebar.component.ts